import React, { useContext } from "react";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import ContactUs from '../../components/ContactUs';
import { UserContext } from '../../context/User';
import { useHistory } from 'react-router-dom';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import AdminHeader from '../../components/Headers/AdminHeader';

 
const ContactUsPage = () => {
  const { isLoggedIn, user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const history = useHistory();

  return (
    <>
      <div>
        {isLoggedIn ? role === 'admin' ? <AdminHeader /> : <LoginHeader /> : <LogoutHeader />}
        <main>
          <ContactUs />
        </main>
        {isLoggedIn ? <LoginFooter /> : <LogoutFooter />}
      </div>
    </>
  );
};

export default ContactUsPage;